import { forwardRef, type InputHTMLAttributes } from "react";
import styles from "./CustomInput.module.scss";
import clsx from "clsx";

interface CustomInputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  error?: boolean;
}

const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(
  ({ icon, error, className, ...props }, ref) => {
    return (
      <div className={styles.wrapper}>
        {icon && <div className={styles.icon}>{icon}</div>}
        <input
          ref={ref}
          className={clsx(
            styles.input,
            icon && styles.hasIcon,
            error && styles.error,
            className
          )}
          {...props}
        />
      </div>
    );
  }
);

CustomInput.displayName = "CustomInput";
export default CustomInput;